import { HighlightingIcon } from "@images/svgIcons/highlightingIcon"
import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleType } from "@modules/programBundle/api/programBundleDto"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { useProgramBundleAthleteSubscription } from "@modules/programBundle/hooks/useProgramBundleSubscription"
import { ProgramSubscriptionStatus } from "@modules/programs/programTypes"
import { HUText } from "@modules/ui/components/huText"
import { isInArray } from "@modules/utils/isInArray"
import { useTheme } from "styled-components"

type ProgramBundleTrialCardProps = {
  programBundle: ProgramBundleEntity
}

export const ProgramBundleTrialCard: React.FC<ProgramBundleTrialCardProps> = ({ programBundle }) => {
  const theme = useTheme()
  const { programBundleStripeSubscriptionInfos } = useProgramBundleAthleteSubscription(programBundle)

  return (
    <>
      {programBundle.trialDuration &&
        (!programBundleStripeSubscriptionInfos ||
          programBundleStripeSubscriptionInfos.subscriptionStatus === ProgramSubscriptionStatus.INACTIVE) &&
        programBundleStripeSubscriptionInfos?.subscriptionStatus !== ProgramSubscriptionStatus.TRIALING &&
        programBundle.isEligibleToTrial && (
          <div className="card align-items-start relative overflow-hidden mb-3 bg-neutralColor-100 pt-3 pb-4 px-5">
            <HighlightingIcon className="absolute top-0 left-0 z-0" />

            <div className="align-items-center z-5 gap-3 flex flex-row">
              <HUText className="z-2" fontStyle="TM">
                {word("programBundle.price.trial.tryBeforeSubscribe")}
              </HUText>
              <InformationAlertIcon color={theme.mainBlack} backgroundColor="transparent" className="z-2" />
            </div>
            <HUText className="z-2" fontStyle="BM">
              {`${word("programBundle.price.trial.description", { count: programBundle.trialDuration })}`}
            </HUText>
          </div>
        )}

      {programBundleStripeSubscriptionInfos?.subscriptionStatus ===
        ProgramSubscriptionStatus.TRIAL_PENDING_CANCELLATION && (
        <div className="card align-items-start relative overflow-hidden mb-3 bg-neutralColor-100 pt-3 pb-4 px-5">
          <HighlightingIcon className="absolute top-0 left-0 z-0" />

          <div className="align-items-center gap-3 flex flex-row">
            <HUText className="z-2" fontStyle="TM">
              {word("programBundle.price.trial.subscriptionCanceled")}
            </HUText>
            <InformationAlertIcon color={theme.mainBlack} backgroundColor="transparent" className="z-5" />
          </div>
          <HUText className="z-2" fontStyle="BM">
            {word("programBundle.price.trial.subscriptionCanceledDescription")}
          </HUText>
        </div>
      )}

      {programBundle.type === ProgramBundleType.VIRTUAL &&
        !programBundle.isEligibleToTrial &&
        !isInArray(
          [ProgramSubscriptionStatus.TRIALING, ProgramSubscriptionStatus.TRIAL_PENDING_CANCELLATION],
          programBundleStripeSubscriptionInfos?.subscriptionStatus,
        ) &&
        programBundle.trialDuration !== null && (
          <div className="card flex flex-column align-items-start relative overflow-hidden mb-3 bg-neutralColor-100 pt-3 pb-4 px-5">
            <HighlightingIcon className="absolute top-0 left-0 z-0" />

            <div className="align-items-center gap-3 flex flex-row">
              <HUText className="z-2" fontStyle="TM">
                {word("programBundle.price.trial.trialPeriodUsedTitle")}
              </HUText>
              <InformationAlertIcon color={theme.mainBlack} backgroundColor="transparent" className="z-5" />
            </div>
            <HUText className="z-2" fontStyle="BM">
              {word("programBundle.price.trial.trialPeriodUsedDescription")}
            </HUText>
          </div>
        )}
    </>
  )
}
